import { useContext } from 'react';
import { SourSearchContext } from './sour-search-context';
export const useSourSearchContext = () => {
    const context = useContext(SourSearchContext);
    if (!context) {
        throw new Error('useSourSearchContext must be used within a SourSearchProvider in an application wrapped in a SourSearchAppProvider');
    }
    return context;
};
//# sourceMappingURL=use-sour-search-context.js.map